import { getOrientation } from '@ginpei/exif-orientation'
export default {
  data: () => ({
    max_image_weight: 10, // in MBytes
  }),
  methods: {
    validateImage(file) {
      if (!file || !file.type) return false

      const types = file.type.split('/')
      if (types[0] !== 'image') {
        return false
      }

      if (file.size >= this.max_image_weight * 1024 * 1024) {
        return false
      }

      return true
    },
    // Parse + rotate the file, and resolve a formdata to send
    parseImage(file, onPreview) {
      return Promise.all([
        // Get file orientation
        Promise.resolve().then(() => {
          if (window.CSS && window.CSS.supports && CSS.supports('image-orientation', 'from-image')) {
            return false
          }
          if (!/\.jpe?g$/i.test(file.name)) {
            return false
          }
          return getOrientation(file).catch(err => console.error(err))
        }),
        // Get url base64
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = ev => resolve(ev.target.result)
          reader.onerror = err => reject(err)
          reader.readAsDataURL(file)
        }),
      ]).then(res => {
        // Orientation
        const orientation = res[0] || {
          rotation: 0,
          flipped: false,
        }

        // Get width/height
        return new Promise((resolve, reject) => {
          const img = new Image()
          img.onload = () => resolve({
            orientation,
            img,
          })
          img.onerror = err => reject(err)
          img.src = res[1]
        })
      }).then(final_res => {
        const { orientation, img } = final_res
        const form = new FormData()

        // Paint canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        if (!canvas.toBlob) {
          form.append('file', file)
          return form
        }

        if (orientation.rotation % 180 === 0) {
          canvas.width = img.naturalWidth
          canvas.height = img.naturalHeight
        } else {
          canvas.width = img.naturalHeight
          canvas.height = img.naturalWidth
        }

        if (orientation.flipped) {
          ctx.translate(canvas.width, 0)
          ctx.scale(-1, 1)
        }
        if (orientation.rotation) {
          ctx.translate(canvas.width / 2, canvas.height / 2)
          ctx.rotate(orientation.rotation * Math.PI / 180)
          ctx.drawImage(img, -img.width / 2, -img.height / 2)
        } else {
          ctx.drawImage(img, 0, 0)
        }
				
        // Convert canvas
        onPreview && onPreview(canvas.toDataURL('image/jpeg', 1))
        return new Promise((resolve) => {
          canvas.toBlob(blob => {
            form.append('file', blob, file.name)
            resolve(form)
          }, 'image/jpeg', 1)
        })
      })
    },
  },
}
